import styled from 'styled-components';

const SpacerTop = styled.div`
  margin-top: 1.5em;
`;

export default SpacerTop;
